<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :invalid-feedback="selectValue.invalidFeedback"
    :state="selectValue.state">
    <div v-if="info">{{info}}</div>
    <b-form-select
      :id="id"
      v-model="selectValue.value"
      :state="selectValue.state"
      :required="isRequired">
      <option v-for="option in options" :value="option.value">
        {{ $t(option.text) }}
      </option>
    </b-form-select>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>
export default {
  name: 'SelectBooleanField',

  props: {
    selectValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'input'
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  data: function() {
    return {
      options: [{value: true, text: 'Yes'}, {value: false, text: 'No'}]
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/SelectBooleanField.vue